import { useNavigate } from "react-router-dom";
import { Button } from "ui/button";
import { twMerge } from "tailwind-merge";

import { PropsAs } from "types/utility";

import Icons from "assets";

export interface BackButtonProps extends Omit<PropsAs<typeof Button>, "children"> {
  children?: React.ReactNode;
  show?: boolean;
  withSeparator?: boolean;
}

const BackButton = ({ show, withSeparator, children = "Back", ...rest }: BackButtonProps) => {
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <>
      <Button
        data-testid="back-button"
        size="small"
        variant="text"
        onClick={(event) => rest.onClick?.(event) ?? navigate(-1)}
        startIcon={
          <Icons.ChevronLeft
            className={twMerge(
              "duration-300 ease-in-out",
              "group-hover:-translate-x-1 group-hover:scale-90",
              "group-focus-visible:-translate-x-1 group-focus-visible:scale-90",
            )}
          />
        }
        {...rest}>
        {children}
      </Button>
      {withSeparator && <div className="h-5 w-px bg-gray-500 mx-4"></div>}
    </>
  );
};

export default BackButton;
